import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"

// Optimistic cookbook collector for the Add-to-cookbook sheet. Tapping a
// cookbook adds/removes this recipe instantly; the full selection is posted in
// the background and only reverts (with a toast) if the server rejects it.
export default class extends Controller {
  static targets = ["checkbox"]
  static values = { url: String }

  // data-action="change->cookbook-collect#toggle" on each cookbook checkbox.
  toggle(event) {
    const box = event.target
    this.save().catch((error) => {
      if (error.name === "AbortError") return // superseded by a newer toggle
      box.checked = !box.checked
      showToast("Couldn't update your cookbooks", { variant: "error" })
    })
  }

  async save() {
    // Each toggle posts the full selection; abort any in-flight save so a
    // slower earlier request can't land after (and clobber) a newer one.
    this.inFlight?.abort()
    this.inFlight = new AbortController()

    const body = new FormData()
    this.checkboxTargets
      .filter((box) => box.checked)
      .forEach((box) => body.append("cookbook_ids[]", box.value))

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": this.csrfToken, Accept: "application/json" },
      body,
      signal: this.inFlight.signal
    })
    if (!response.ok) throw new Error(`save failed: ${response.status}`)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
